import { render, staticRenderFns } from "./FiscalPrinterNew.vue?vue&type=template&id=5e189188&scoped=true&"
import script from "./FiscalPrinterNew.vue?vue&type=script&lang=js&"
export * from "./FiscalPrinterNew.vue?vue&type=script&lang=js&"
import style0 from "./FiscalPrinterNew.vue?vue&type=style&index=0&id=5e189188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e189188",
  null
  
)

export default component.exports